import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import SimpleCheckBox from "../checkbox/check";
import SimpleAutoCompleteMultiple from "../auto-complete/autocomplete-multiple-create";
import { FormattedMessage } from "react-intl";
import ClearIcon from '@mui/icons-material/Clear';

export default function DialogAddMultiple(props) {
  const { selected, options, checked, changeValues, save, open, close, title, intl, checkboxLabel, checkboxStateName, autoCompleteLabel, autoCompleteStateName } = props;

  return (
    // Removido o 'PaperProps' 
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title-org-mat"
    >
      <DialogTitle id="form-dialog-title-org-mat">
        {title}
        <ClearIcon onClick={close} style={{ float: 'right', cursor: 'pointer' }} />
      </DialogTitle>

     
      <DialogContent className="scrollable-dialog">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SimpleCheckBox label={checkboxLabel} name={checkboxStateName} stateName={checkboxStateName} changeSelect={changeValues} selected={checked} />
          </Grid>
          <Grid item xs={12}>
            <SimpleAutoCompleteMultiple
              label={autoCompleteLabel}
              options={options}
              stateName={autoCompleteStateName}
              changeSelect={changeValues}
              selected={selected} />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Botões movidos para fora do conteúdo e para dentro do DialogActions */}
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={close}>
          {intl.formatMessage({ id: "cancel" })}
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={save}
        >
          {<FormattedMessage id="save" />}
        </Button>
      </DialogActions>
    </Dialog>
  );
}